/**
 * Delivery
 */

export const delivery = {
    namespaced: true,
    state: () => ({
        items: [],
        selected: null
    }),
    mutations: {
        setDeliveryMethods: (state, payload) => {
            state.items = [...payload.data.items];
        },
        select: (state, value) => {
            state.selected = value;
        },
    },
    actions: {
        getDeliveryMethods: ({ commit }, payload) => {
            let params = {};

            // Если выбран плательщик, добавляем параметр в запрос
            if (typeof payload !== 'undefined' && typeof payload.payer !== 'undefined') {
                params.payer = payload.payer
            }

            axios.get('/ajax/delivery-methods', { params: params })
                .then(request => {
                    commit('setDeliveryMethods', {
                        ...request.data,
                        // amount: parseFloat(request.data.amount),
                        // oldAmount: parseFloat(request.data.old_amount),
                        // hasUnavailable: request.data.has_unavailable
                    });
                });
        },
    },
    getters: {
        items: state => {
            return state.items;
        },
    },
}
